import { render, staticRenderFns } from "./Doc.vue?vue&type=template&id=53be70f7"
import script from "./Doc.vue?vue&type=script&lang=ts"
export * from "./Doc.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports